module.exports = __webpack_public_path__ + "static/pancit-w-pandesal-2-786645291a3120ca9136a662f1c8e457.jpg";